module.exports = __webpack_public_path__ + "static/media/Patient_Resources.49a22486.pdf";